import { render, staticRenderFns } from "./ResumoErrosSamp.vue?vue&type=template&id=42010a12&"
import script from "./ResumoErrosSamp.vue?vue&type=script&lang=js&"
export * from "./ResumoErrosSamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
